import CoreComponent from '../../core/CoreComponent.vue';
import Swiper, { Pagination, Keyboard } from 'swiper';
import { carouselClicksTracking } from '../../core/ACDLHandler';
import 'swiper/css';
export default {
  extends: CoreComponent,
  mounted() {
    const bulletButtonAriaLabel = window.Granite.I18n.get('cardcontainer.carousel.pagination');
    const announcementCarousel = this.cmpEl.querySelector('.cmp-announcementContainer-carousel__content');
    if (announcementCarousel) {
      // Add click event to navigate to the first CTA link
      const cardImages = this.cmpEl.querySelectorAll('.card-image');
      cardImages.forEach(image => {
        const card = image.closest('.cmp-announcementContainer__card');
        const firstCtaElement = card?.querySelector('.cmp-button');
        if (firstCtaElement) {
          image.style.cursor = 'pointer';
          image.addEventListener('click', () => {
            firstCtaElement.click();
          });
        }
      });
      var contentSwiper = new Swiper(announcementCarousel, {
        slidesPerView: 1,
        spaceBetween: 16,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        modules: [Keyboard, Pagination],
        keyboard: {
          enabled: true,
          onlyInViewport: true
        },
        pagination: {
          el: this.cmpEl.querySelector('.cmp-announcementContainer--carousel-pagination'),
          clickable: true,
          bulletElement: 'button',
          renderBullet: function (index) {
            let tabindexAttr = index === 0 ? 'tabindex="0"' : 'tabindex="-1"';
            return `<button class="dot swiper-pagination-bullet" aria-label="${bulletButtonAriaLabel}" ${tabindexAttr}><span class="invisible">${bulletButtonAriaLabel}</span></button>`;
          }
        },
        on: {
          slideChange: function () {
            carouselClicksTracking(cmpId, "Announcements Carousel", this.snapIndex);
          }
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      });
      const paginationContainers = this.cmpEl.querySelectorAll('.cmp-announcementContainer--carousel-pagination');
      paginationContainers.forEach(paginationContainer => {
        const paginationBullets = paginationContainer.querySelectorAll('.swiper-pagination-bullet');
        const bulletCount = paginationBullets.length;
        const nextButton = document.createElement('div');
        nextButton.classList.add('swiper-button-next');
        const prevButton = document.createElement('div');
        prevButton.classList.add('swiper-button-prev');
        prevButton.addEventListener('click', () => {
          contentSwiper.slidePrev();
        });
        nextButton.addEventListener('click', () => {
          contentSwiper.slideNext();
        });

        //check if closet parent swiper-button-prev is there
        var swiperInitializedElement = "";
        var prevButtonElement = "";
        var nextButtonElement = "";
        const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (paginationContainer.classList.contains('swiper-pagination-lock')) {
              prevButton.style.display = 'none';
              nextButton.style.display = 'none';
            } else {
              prevButton.style.display = 'block';
              nextButton.style.display = 'block';
              swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
              prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
              nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
              if (prevButtonElement == null && nextButtonElement == null) {
                paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
                paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
              }
            }
          });
        });
        const config = {
          attributes: true,
          childList: true,
          subtree: true
        };
        observer.observe(paginationContainer, config);
        window.addEventListener('resize', () => {
          //  MutationObserver
          observer.disconnect();
          observer.observe(paginationContainer, config);
          if (paginationContainer.classList.contains('swiper-pagination-lock')) {
            prevButton.style.display = 'none';
            nextButton.style.display = 'none';
          } else {
            prevButton.style.display = 'block';
            nextButton.style.display = 'block';
            swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
            prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
            nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
            if (prevButtonElement == null && nextButtonElement == null) {
              paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
              paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
            }
          }
        });
        if (bulletCount >= 2) {
          prevButton.style.display = 'display';
          nextButton.style.display = 'display';
          swiperInitializedElement = paginationContainer.closest('.swiper-initialized');
          prevButtonElement = swiperInitializedElement.querySelector('.swiper-button-prev');
          nextButtonElement = swiperInitializedElement.querySelector('.swiper-button-next');
          if (prevButtonElement == null && nextButtonElement == null) {
            paginationContainer.parentNode.insertBefore(prevButton, paginationContainer);
            paginationContainer.parentNode.insertBefore(nextButton, paginationContainer);
          }
        }
      });
    }
  }
};